export default "__VITE_ASSET__052a7f86__"